<tec-tile [title]="'PANEL.MANUAL_VALIDATION_PROCESSES' | translate" [badgeSquare]="`${totalPending}`">
	@if (rolePermissions.canViewPanelDeveloperCurl() || content?.length > 0) {
		<ng-container actions>
			@if (rolePermissions.canViewPanelDeveloperCurl()) {
				<tec-button-icon
					icon="icon-code-brackets"
					type="default"
					size="sm"
					(clickEvent)="openCurlModal()"
				/>
			}
			@if (content?.length > 0) {
				<tec-button [label]="'BUTTON.CHECK' | translate" size="sm" (clickEvent)="goToInProgressProcesses($event)" />
			}
		</ng-container>
	}
	<tec-table [rows]="content" [config]="config" (rowEvent)="tableRow($event)" />
</tec-tile>

@if (curlModalOpen()) {
	<app-modal-curl-request
		[titleKey]="'PANEL.CURL_MODAL.TITLE_PENDING_VALIDATION'"
		[curlText]="getPendingValidationCurl()"
		(closeEvent)="closeCurlModal()"
	/>
}
